import { render, staticRenderFns } from "./MBFDialog.vue?vue&type=template&id=6af9c3fa&scoped=true"
import script from "./MBFDialog.vue?vue&type=script&lang=js"
export * from "./MBFDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9c3fa",
  null
  
)

export default component.exports